<div class="historico-caixa-page">
  <div class="historico-filtros">
    <div class="filtro-campo filtro-usuario">
      <label>Operador</label>
      <kendo-dropdownlist
        [data]="usuariosFiltro"
        [defaultItem]="operadorTodos"
        textField="nome"
        valueField="id"
        [valuePrimitive]="true"
        [(ngModel)]="filtro.idOperador"
        class="filtro-control">
      </kendo-dropdownlist>
    </div>

    <div class="filtro-campo filtro-periodo">
      <label>Data de abertura</label>
      <div class="periodo-controles">
        <kendo-datepicker
          [(ngModel)]="filtro.dataAberturaInicio"
          format="dd/MM/yyyy"
          placeholder="De"
          class="filtro-control">
        </kendo-datepicker>
        <kendo-datepicker
          [(ngModel)]="filtro.dataAberturaFim"
          format="dd/MM/yyyy"
          placeholder="Até"
          class="filtro-control">
        </kendo-datepicker>
      </div>
    </div>

    <div class="filtro-checkbox">
      <input type="checkbox" id="filtrarAbertos" name="filtrarAbertos" class="k-checkbox" kendoCheckBox [(ngModel)]="filtro.abertos" (ngModelChange)="apliqueFiltros()">
      <label for="filtrarAbertos">Filtrar abertos</label>
    </div>

    <div class="filtro-acoes">
      <button type="button" class="btn-filtro btn-limpar" (click)="limpeFiltros()">
        <i class="fas fa-filter"></i>
        Limpar filtros
      </button>
      <button type="button" class="btn-filtro btn-aplicar" (click)="apliqueFiltros()">
        <i class="fas fa-search"></i>
        Aplicar filtros
      </button>
    </div>
  </div>

  <div class="historico-tabela">
    <kendo-grid [data]="historicoCaixas" [scrollable]="'none'" [pageable]="pageable" [pageSize]="pageSize" [skip]="skip" [loading]="carregando" (pageChange)="proximaPagina($event)">
      <kendo-grid-messages
        pagerPage="Página"
        pagerOf="de"
        pagerItems="registros"
        noRecords="Nenhum histórico de caixa encontrado."
        loading="Carregando"
        pagerItemsPerPage="por página">
      </kendo-grid-messages>
      <kendo-grid-column field="operador" title="Operador" [width]="170">
        <ng-template kendoGridCellTemplate let-dataItem>
          {{
            dataItem.online
              ? 'Online'
              : (dataItem.operador ? dataItem.operador.nome : '-')
          }}
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="horaAbertura" title="Aberto às" [width]="145" >
        <ng-template kendoGridCellTemplate let-dataItem>
          {{ dataItem.horaAbertura | date:'dd/MM/yyyy HH:mm' }}
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="horaFechamento" title="Fechado às" [width]="145" >
        <ng-template kendoGridCellTemplate let-dataItem>
          <span *ngIf="dataItem.horaFechamento; else aberto">{{ dataItem.horaFechamento  | date:'dd/MM/yyyy HH:mm' }}</span>
          <ng-template #aberto>
            <label class="statusAberto">ABERTO</label>
          </ng-template>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="saldoInicial" title="Saldo inicial" [width]="120">
        <ng-template kendoGridCellTemplate let-dataItem>
          {{ dataItem.saldoInicial | currency:'BRL' }}
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="resumo.saldoDinheiro" title="Saldo final(Dinheiro)" [width]="155">
        <ng-template kendoGridCellTemplate let-dataItem>
          {{ dataItem.saldoDinheiro | currency:'BRL' }}
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="resumo.saldo" title="Saldo final(Total)" [width]="145">
        <ng-template kendoGridCellTemplate let-dataItem>
          {{ dataItem.saldo | currency:'BRL' }}
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="totalFiado" title="Fiado" [width]="100" *ngIf="moduloFiadoAtivo">
        <ng-template kendoGridCellTemplate let-dataItem>
          {{ dataItem.totalFiado | currency:'BRL' }}
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="totalGeralComFiado" title="Total com fiado" [width]="140" *ngIf="moduloFiadoAtivo">
        <ng-template kendoGridCellTemplate let-dataItem>
          {{ dataItem.totalGeralComFiado | currency:'BRL' }}
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column title="Ações" [width]="165">
        <ng-template kendoGridCellTemplate let-dataItem>
          <div class="acoes-caixa">
            <button type="button" class="btn-acao btn-detalhes" (click)="verDetalhes(dataItem)">
              <i class="fas fa-eye"></i>
              Detalhes
            </button>
            <button type="button" (click)="imprimir(dataItem)" class="btn-acao btn-imprimir" title="Imprimir">
              <i class="fas fa-print"></i>
            </button>
          </div>
        </ng-template>
      </kendo-grid-column>
    </kendo-grid>
  </div>
</div>

<ng-template #aguardeImpressao>
  <span>
  <i class="k-icon k-i-loading mr-1"></i>
    Aguarde enquanto o relatório é impresso...
  </span>

</ng-template>
<kendo-dialog *ngIf="caixaDetalhado" (close)="fecharTransacoes()" >
  <kendo-dialog-titlebar>
    Detalhes do caixa {{ caixaDetalhado.id }} - {{ caixaDetalhado.horarioAbertura | date:'dd/MM/yyyy HH:mm' }}
  </kendo-dialog-titlebar>
  <div style="width: 60vw">
    <app-grid-transacoes-caixa [caixa]="caixaDetalhado" [resumo]="resumoCaixaDetalhado" [editavel]="false"></app-grid-transacoes-caixa>
  </div>

</kendo-dialog>
